// Module
var code = "<div> <template> <span v-if=\"value?.display_name?.length > 0\">{{ value.display_name }}</span> <span v-else-if=\"value?.updated_utc\">updated on <formatted-date :date=\"value.updated_utc\"></formatted-date></span> </template> </div>";
// Exports
export default code;